export const Footer = () => {
  return (
    <footer className='w-full bg-gray-800 text-white px-4 py-4'>
      <p>Website built with React.</p>
    </footer>
  )
}